import CommissionDetail from "pages/accountManagement/CommisionDetailsNew";
import ViewUnderwriter from "pages/myunderwriters/viewUnderwriter";
import motorcertificateConfigPage from "pages/productconfig/motorcertificateconfig";
import SingleClientQuotation from "pages/quotations/SingleClientQuotation";

export default {
  // Root 
  home: "/",
  signup: "/signup",
  login: "/login",
  forgotPassword: "/forgot-password",
  verifyCode: "/verify-code",
  verifyOTP: "/verify-otp",
  resetPassword: "/reset-password",
  credentials: "/credentials",
  verify: "/verify",
  kyc: "/kyc",
  reset: "/reset",
  resetPassword: "/reset-password",
  reset2: "/reset2",
  profilesetup: "/profile-setup",
  kycsetup: "/kyc-setup",

  // Nested Dashboard Routes
  dashboard: "/dashboard",
  underwriters: "/dashboard/underwriters",
  singleunderwriter:  "/dashboard/underwriters/view/:id",

  // Valuation
  valuation: "/dashboard/valuation/panel",
  valuationLegacy: "/dashboard/valuation",
  valuationView: "/dashboard/valuation/view/:id",
  valuationConfig: "/dashboard/valuation/config",
  valuationConfigView: "/dashboard/valuation/config/view/:id",
  valuationRequests: "/dashboard/valuation/requests",

  // Integration
  integrationpanel: "/dashboard/integration/panel",
  integrationDMVIC: "/dashboard/integration/dmvic",

  // Quotations (lATEST)
  quotations: "/dashboard/quotations",
  viewQuotation: "/dashboard/quotations/view/:id",
  assetDetails: "/dashboard/quotations/asset-details/:id",
  clientQuotations: '/dashboard/quotations/client-quotations',
  singleClientQuotation: '/dashboard/quotations/:id',

  // Quotations
  quotations1: "/dashboard/quotations1",
  viewQuotation1: "/dashboard/quotations1/view/:id",
  assetDetails1: "/dashboard/quotations1/asset-details/:id",

  // claims
  claims: "/dashboard/claims",
  viewClaim: "/dashboard/claims/view/:id",
  claimsPending: "/dashboard/claims-pending-approval",
  viewClaimsPending: "/dashboard/claims-pending-approval/view/:id",

  // renewals
  renewals: "/dashboard/renewals",
  viewRenewal: "/dashboard/renewals/view",

  // Quotation Request (Latest)
  quotationRequests: "/dashboard/quotation-requests",
  viewQuotationRequest: "/dashboard/quotation-requests/view/quo-req/:id",

  // Quotation Request
  quotationRequests1: "/dashboard/quotation-requests1",
  viewQuotationRequest1: "/dashboard/quotation-requests1/view/:id",

  // Request
  requests: "/dashboard/requests",

  // policies
  policies: "/dashboard/policies",
  viewPolicy: "/dashboard/policies/view/:id",

  // portfolio
  portfolio: "/dashboard/portfolio",
  singlepolicy: "/dashboard/portfolio/:id",

  // Reports
  reportConfig: "/dashboard/reports/config",
  viewReportConfig: "/dashboard/reports/config/view-report",
  viewReportGroup: "/dashboard/reports/config/view-group",
  viewUsers: "/dashboard/reports/config/view-users",

  // UserManagement
  usmgRoles: "/dashboard/usmg/roles",
  usmgRoleView: "/dashboard/usmg/roles/view/:id",
  usmgDepartments: "/dashboard/usmg/departments",
  usmgViewDepartment: "/dashboard/usmg/departments/view/:id",
  usmgUsers: "/dashboard/usmg/users",
  usmgViewUser: "/dashboard/usmg/users/view/:id",
  usmgUserGroup: "/dashboard/usmg/usergroup",
  usmgViewUserGroup: "/dashboard/usmg/usergroup/view/:id",
  usmgChat: "/dashboard/usmg/chat",
  usmgViewChat: "/dashboard/usmg/chat/view",
  usmgViewSecurity: "/dashboard/usmg/security/view/:id",
  usmgSecurity: "/dashboard/usmg/security",
  usmgChatGroups: "/dashboard/usmg/chatgroups",

  //wallet
  wallet: "/dashboard/account-management/wallet",
  viewWallet: "/dashboard/account-management/wallet/view/:id",
  viewCommission: "/dashboard/account-management/wallet/view/commission/:id", 
  // viewCommissionEntries: "/dashboard/account-management/wallet/view/commission/:id",

  // commissions
  commissions: "/dashboard/commissions",

  // profession
  profession: "/dashboard/profession",

  // profile
  profile: "/dashboard/profile",

  // appointments
  appointments: "/dashboard/appointments",

  // Tnc
  tnc: "/dashboard/tnc",
  tenders: "/dashboard/tenders",

  ptnc: "/tnc",



  // Settlement
  settlement: "/dashboard/settlement",
  channels: "/dashboard/channels",
  settlementConfig: "/dashboard/settlement/config",
  configDetails: "/dashboard/settlement/config/:id",
  settlementDetails: "/dashboard/settlement/:id",
  channelDetails: "/dashboard/settlement/channel/:id",

   //settlements
   settlements: "/dashboard/settlements",
   settlements_requests: '/dashboard/settlements/requests',
   settlements_request: '/dashboard/settlements/requests/:id',
   settlements_configs: '/dashboard/settlements/configs',
   settlements_config: '/dashboard/settlements/config/:id',


  // Reviews
  reviews: "/dashboard/reviews",

  // Chat
  chat: "/dashboard/chat",
  chatConversation: "/dashboard/chat/:id",

  // tax
  tax: "/dashboard/account-management/tax",
  taxDetails: "/dashboard/account-management/tax/details/:id",

  // Relationship Manager
  rm: "/dashboard/rm",
  rmDetails: "/dashboard/rm/:id",

  salesrep: "/dashboard/salesrep",
  viewSalesRep: "/dashboard/salesrep/:id",

  // leads
  openLeads: "/dashboard/open-leads",
  leads: "/dashboard/leads",
  viewLeads: "/dashboard/leads/ld/:id",

  // Fees
  fees: "/dashboard/fees",
  feeDetails: "/dashboard/account-management/fees/details/:id",

  // domains
  domains: "/dashboard/domains",

  // Incentives
  incentives: "/dashboard/incentives",
  incentiveDetails: "/dashboard/incentives/:id",

  // Schemes
  schemes: "/dashboard/schemes",
  schemeDetails: "/dashboard/schemes/:schemeId",
  groupSchemeDetails: "/dashboard/schemes/:schemeId/sch-grp/:groupId",
  underwriterRates: "/dashboard/schemes/:schemeId/underwriterRate/sch-grp/:groupRef",
  groupSchemeManagement: "/dashboard/schemes/:schemeId/manage-scheme",

  //products
  products: "/dashboard/products",


  //products
  setup: "/dashboard/setup",
  addbenefit: "/dashboard/setup/addbenefit",
  viewbenefit: "/dashboard/setup/benefit/:id",
  adddmvic: "/dashboard/setup/adddmvic",
  addproduct: "/dashboard/setup/product/new",
  editproduct: "/dashboard/setup/product/:id/edit",
  viewproduct: "/dashboard/setup/product/:id",
  addrate: "/dashboard/setup/rates",
  productlist: "/dashboard/setup/products",
  viewproduct: "/dashboard/setup/product/:id",
  myunderwriters: "/dashboard/setup/myunderwriters",
  myaccount: "/dashboard/myaccount",


  //config 
  benefitconfig: "/dashboard/setup/product/:id/benefit",
  policynoconfig: "/dashboard/setup/product/:id/policyno",
  motorcertconfig: "/dashboard/setup/product/:id/motorcert",
  excessconfig: "/dashboard/setup/product/:id/excess",
  accountingconfig: "/dashboard/setup/product/:id/accounting",
  premiumpricing: "/dashboard/setup/product/:id/premiumpricing",
  requirementsconfig: "/dashboard/setup/product/:id/requirements",
  productpolicyconfig: "/dashboard/setup/product/:id/productpolicy",
  paymentconfig: "/dashboard/setup/product/:id/payment",
  tnc: "/dashboard/setup/product/:id/tnc",
  valuationproductconfig: "/dashboard/setup/product/:id/valuation",
  productDocumentConfig: "/dashboard/setup/product/:id/document",
    coverDetailsConfig: "/dashboard/setup/product/:id/coverdetails",
    liabilityconfig: "/dashboard/setup/product/:id/liability",

  //products Config //  viewproduct: "/dashboard/setup/product/:id",
  ProductDetails: "/dashboard/config/productdetails",
  policynumberconfig: "/dashboard/config/policynumberconfig",
  motorcertificateConfig: "/dashboard/config/motorcertificateconfig",
  benefitsconfig: "/dashboard/setup/product/:id/benefitsconfig",
  excessliabilityconfig: "/dashboard/config/excessliabilityconfig",
  Premiumpricingconfig: "/dashboard/config/premiumpricingconfig",
  PaymentConfig: "/dashboard/config/paymentconfig",
  PolicyProductConfig: "/dashboard/config/policyconfig",
  AccountingConfig: "/dashboard/config/accountingconfig",
  requirements: "/dashboard/config/productrequirementsconfig",
  terms: "/dashboard/config/termsandconditionsconfig",

  // Dashboards
  Inventory: "/dashboard/inventory",
  Reports: "/dashboard/reports",
  invoices: "/dashboard/reports/invoices",
  commissionsreports: "/dashboard/reports/commissions",
  renewalsreports: "/dashboard/reports/renewals",
  singlerenewalpolicy: "/dashboard/reports/renewals/:id",

  CommissionsAccount: "/dashboard/account-management/commissions",
  commissionDetailAccount: "/dashboard/account-management/commissions/:id",

  //Quotations
  viewQuotation: "/dashboard/quotations/:id",
  DirectQuotation: "/dashboard/direct-quotation",
  ViewDirectQuotation: "/dashboard/direct-quotation/:id",
  ClientInvoices: "/dashboard/Client-invoices",
  ViewClientInvoices:"/dashboard/view-client-invoices/:id",
  ClientHelpRequests: "/dashboard/client-help-requests",
  ViewClientHelpRequest: "/dashboard/view-client-help-request/:id",
  viewUnderwriter: "/dashboard/viewUnderwriter/:id",
    myunderwriterview: "/dashboard/myunderwriterview/:id",

  //Accounting
  AccountLanding: "/dashboard/AccountingLanding",
  AccountingCommission:"/dashboard/Accounting/Commission",
  AccountingPolicies: "/dashboard/accounting/Policies",
  AccountingInvoices: "/dashboard/accounting/Invoices",
  AccountingTaxes: "/dashboard/accounting/Taxes",
  AccountingWallet: "/dashboard/accounting/Wallet",


  //Modules
  ModulesView: "/dashboard/modules/view",
  UnderwrittingModule: "/dashboard/modules/underwritting",
  UserManagementModule: "/dashboard/modules/usermanagement",
  ViewUserRole: "/dashboard/modules/usermanagement/viewrole/:id",
  ViewUserDetails: "/dashboard/modules/usermanagement/viewuser/:id",
  // Clients (added)
  clientManagement: "/dashboard/client-management",
  viewClient: "/dashboard/client-management/view/:id",

  // Service Providers
  serviceProviders: "/dashboard/service-providers",
  serviceProviderDetails: "/dashboard/service-providers/:id"
};
